import React, { useEffect, useRef, useState } from 'react';
import { createGalaxy } from '../lib/galaxy';

/**
 * Decorative backdrop for the hero. The simulation itself lives in lib/galaxy
 * so it stays testable outside React and never re-runs on a re-render.
 */
const GalaxyCanvas = ({ className = '' }) => {
  const ref = useRef(null);
  const controller = useRef(null);
  const [paused, setPaused] = useState(false);
  const [reduced, setReduced] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const change = () => setReduced(query.matches);
    query.addEventListener('change', change);
    return () => query.removeEventListener('change', change);
  }, []);

  useEffect(() => {
    if (!ref.current) return undefined;
    const galaxy = createGalaxy(ref.current);
    controller.current = galaxy;
    return () => galaxy.destroy();
  }, [reduced]);

  useEffect(() => { controller.current?.setPaused?.(paused); }, [paused, reduced]);

  return <><canvas ref={ref} className={className} aria-hidden="true" />{!reduced && <button type="button" className="galaxy-control" aria-pressed={paused} aria-label="Pause galaxy animation" onClick={() => setPaused(value => !value)}>{paused ? 'Resume stars' : 'Pause stars'} <span aria-hidden="true">{paused ? '▷' : 'Ⅱ'}</span></button>}</>;
};

export default GalaxyCanvas;
